export const GET_VERSION_WEB_API_SUCCESS = 'GET_VERSION_WEB_API_SUCCESS';
